import { Component } from '@angular/core';

enum DeductibleLookupFlow {
  lookup,
  results
}

@Component({
  selector: 'pgh-deductible-lookup',
  templateUrl: './deductible-lookup.component.html',
  styleUrl: './deductible-lookup.component.scss'
})
export class DeductibleLookupComponent {
  deductibleLookupFlow = DeductibleLookupFlow;
  currentPage = DeductibleLookupFlow.lookup;

  changeFlow(flow: DeductibleLookupFlow) {
    this.currentPage = flow;
  }
}
